import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InvoiceListInnerStyle from './css/InvoiceListInnerStyle'
import { ContentInner } from '../../layout/Content'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import { invoiceListControllerContext } from './InvoiceListController'
import { formatNumber } from '../../utilities/utilities'
import { appContext } from '../../../App'
import InvoiceItemController from '../invoiceitem/InvoiceItemController'

function InvoiceListInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const invoiceListController = useContext(invoiceListControllerContext)
  const invoiceList = invoiceListController.invoiceList[0]
  const [selectAll, setSelectAll] = invoiceListController.selectAll
  const { addSelectedInvoiceId, removeSelectedInvoiceId, foundDeletableInvoice,
          invoiceListSorted, sortInvoiceListBy, getInvoiceById, refreshInvoiceList } = invoiceListController
  const startSlice = invoiceListController.startSlice[0]
  const endSlice = invoiceListController.endSlice[0]
  const [sortBy, setSortBy] = invoiceListController.sortBy
  const deleteableInvoices = ['Unpaid', 'Inactive']

  const onClickInvoiceItem = async (e) => {
    if (e.target.type === 'checkbox') return
    const item = e.target.closest('.invoice-item')
    const invoice = await getInvoiceById(app, item.id)
    if (invoice) setContent(<InvoiceItemController invoice={invoice} />)
    else {
      const showMessageBox = () => {
        const onClick = async () => {
          await refreshInvoiceList()
          ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
        }
        ReactDOM.render (
          <ModalWindow id='mw-parent' height='20' width='25' header='Invoice Not Found' footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>Invoice file/record no longer exist.</div>
              </div>
              <div className='button-container'>
                <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
              </div>
            </div>
          </ModalWindow>,
          document.getElementById('modal-form-container')
        )
      }

      showMessageBox()
    }
  }

  const onClickCheckBox = (e) => {
    const item = e.target.closest('.invoice-item')
    const checked = e.target.checked
    if (checked) addSelectedInvoiceId(item.id)
    else removeSelectedInvoiceId(item.id)
  }

  const onClickSort = (e) => {
    const header = e.target.closest('.title-header')
    sortInvoiceListBy(header.id)
    setSortBy(header.id)
  }

  const onClickSelectAll = (e) =>  { setSelectAll(!selectAll) }

  let userHaveFC = true
  if (app.client.signed_in !== 'admin') userHaveFC = app.client.signed_in.user_access.invoice_fc

  return (
    <ContentInner>
      <div id='table-invoice-list-inner-container'>
        <table className="table striped-table">
          <thead>
            <tr>
              <th style={{textAlign: 'left'}}>
                <div
                  id='invoice_date'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Invoice Date</div>
                  <span>
                    {
                      (sortBy === 'invoice_date') ?
                        (invoiceListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th style={{textAlign: 'center'}}>
                <div
                  id='invoice_number'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Invoice Number</div>
                  <span>
                    {
                      (sortBy === 'invoice_number') ?
                        (invoiceListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th style={{textAlign: 'left'}}>
                <div
                  id='sold_to'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Sold To</div>
                  <span>
                    {
                      (sortBy === 'sold_to') ?
                        (invoiceListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th style={{textAlign: 'left'}}>
                <div
                  id='prepared_by'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Prepared By</div>
                  <span>
                    {
                      (sortBy === 'prepared_by') ?
                        (invoiceListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>

              {/*
              <th style={{textAlign: 'right'}}>
                <div
                  id='total_amount_due'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Total Amount Due</div>
                  <span>
                    {
                      (sortBy === 'total_amount_due') ?
                        (invoiceListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              */}

              <th style={{textAlign: 'right'}}>
                <div
                  id='total_sales'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Total Sales</div>
                  <span>
                    {
                      (sortBy === 'total_sales') ?
                        (invoiceListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>

              <th style={{textAlign: 'center'}}>
                <div
                  id='invoice_status'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Status</div>
                  <span>
                    {
                      (sortBy === 'invoice_status') ?
                        (invoiceListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              {
                (userHaveFC)
                ? <th className='empty-header' style={{display: (foundDeletableInvoice) ? 'block' : 'none', paddingTop: '18%'}}>
                    <button
                      type="button"
                      className={(foundDeletableInvoice) ? 'pospro-action-btn toolbar-btn' : 'pospro-action-btn disabled-button'}
                      disabled={!foundDeletableInvoice}
                      id="select-all-btn"
                      title="Select/Unselect all selectable items on the list"
                      onClick={onClickSelectAll}>
                      {
                        (selectAll) ? (<span style={{fontSize: '1rem' }}><FontAwesomeIcon icon='check-square'/></span>)
                        : (<span style={{fontSize: '1rem'}}><FontAwesomeIcon icon='square'/></span>)
                      }
                    </button>
                  </th>
                : null
              }
            </tr>
          </thead>
          {
            invoiceList ?
              invoiceList.slice(startSlice, endSlice).map((invoice, index) => (
                <tbody
                  key={invoice._id}
                  id={invoice._id}
                  onClick={onClickInvoiceItem}
                  className='invoice-item'>
                  <tr className={`row-text-color ${invoice.status.replace(' ', '')}`}>
                    <td style={{textAlign: 'left'}}>
                      {new Date(invoice.invoice_date).toLocaleString("en-us", { timeZone: invoice.client_timezone }).split(',')[0]} {invoice.client_timezone}
                    </td>
                    <td style={{textAlign: 'center'}}>{invoice._id.toUpperCase()}</td>
                    <td style={{textAlign: 'left'}}>{invoice.customer_details.sold_to}</td>
                    <td>{invoice.prepared_by}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber(invoice.invoice_summary.total_sales)}</td>
                    <td style={{textAlign: 'center', fontFamily: 'Corbel'}}><span className={`label-status ${invoice.status.replace(' ', '')}`}>{invoice.status}</span></td>

                    <td style={{display: (foundDeletableInvoice && userHaveFC) ? 'flex' : 'none'}}>
                    {
                      (deleteableInvoices.find((di) => (di === invoice.status))) ?
                        <input className='invoice-checkbox' onClick={onClickCheckBox} type='checkbox'/>
                      : null
                    }
                    </td>

                  </tr>
                </tbody>
              ))
            : null
          }

        </table>
      </div>
      <InvoiceListInnerStyle />
    </ContentInner>
  )
}

export default React.memo(InvoiceListInner)
